(function(){
  function isRootHost(host){
    host=(host||'').toLowerCase().replace(/^www\./,'');
    return host==='rootelixirs.com'||host==='rootmixers.com';
  }

  function normalizeInternalLink(link){
    var raw=link.getAttribute('href');
    if(!raw||raw.charAt(0)==='#'||raw.indexOf('mailto:')===0||raw.indexOf('tel:')===0||raw.indexOf('javascript:')===0)return;

    var next=raw;
    try{
      var parsed=new URL(raw,window.location.origin);
      if(parsed.origin===window.location.origin||isRootHost(parsed.hostname)){
        next=parsed.pathname+parsed.search+parsed.hash;
      }else{
        return;
      }
    }catch(error){return;}

    if(next==='/collections/bottle-shop'||next==='/collections/all')next='/#root-flavors';
    if(next==='/pages/faq-1')next='/pages/faq';
    if(next==='/blogs/blogs/'||next==='/blogs/blogs')next='/blogs/blogs';

    if(next!==raw)link.setAttribute('href',next);
  }

  function repairLinks(scope){
    (scope||document).querySelectorAll('a[href]').forEach(normalizeInternalLink);
  }

  function markContentTemplate(){
    var html=document.documentElement;
    var path=window.location.pathname;
    if(path.indexOf('/blogs/')===0){
      if(/^\/blogs\/[^/]+\/[^/]+/.test(path))html.classList.add('root-article-template');
      else html.classList.add('root-blog-template');
    }
    if(path==='/pages/contact')html.classList.add('root-contact-template');
    if(path==='/pages/faq'||path==='/pages/faq-1')html.classList.add('root-faq-template');
    if(path.indexOf('/policies/')===0)html.classList.add('root-content-template','root-policy-template');
    if(path.indexOf('/pages/')===0&&!html.classList.contains('rabout')&&!html.classList.contains('rloc')&&!html.classList.contains('rpour')&&!html.classList.contains('rhost'))html.classList.add('root-content-template');
  }

  function run(){markContentTemplate();repairLinks(document);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
  document.addEventListener('shopify:section:load',function(event){repairLinks(event.target||document);});
})();
